
import axios from 'axios'
import constant from '../main.constants';
export default axios.create({
    baseURL: constant.serverAddress,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    withCredentials: true
})